import { render } from "./LocalUpload.vue?vue&type=template&id=649b9615&ts=true"
import script from "./LocalUpload.vue?vue&type=script&lang=ts"
export * from "./LocalUpload.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__